// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: process.env.VUE_APP_LOGO_NAME, // Will update name in navigation menu (Branding)
    // eslint-disable-next-line global-require,import/no-dynamic-require
    appLogoImage: process.env.VUE_APP_LOGO || require('@/assets/images/logo/logo.svg'), // Will update logo in navigation menu (Branding)
    // eslint-disable-next-line global-require
    appLogoAdreachImage: process.env.VUE_APP_LOGO_ADREACH,
    appLogoWhiteImage: process.env.VUE_APP_LOGO_WHITE,
    appLogoCollapseImage: process.env.VUE_APP_LOGO_COLLAPSE,
    appLogoWhiteAdreachImage: process.env.VUE_APP_LOGO_ADREACH_WHITE,
    appLogoCollapseAdreachImage: process.env.VUE_APP_LOGO_ADREACH_COLLAPSE,
    appFaviconImage: process.env.VUE_APP_FAVICON,
    appPriorityFaviconImage: process.env.VUE_APP_LOGO_COLLAPSE,
  },
  layout: {
    isRTL: false,
    skin: 'semi-dark', // light, dark, bordered, semi-dark
    routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: true,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: true,
    enableScrollToTop: true,
  },
}
